import React, {useMemo} from 'react';
import ChartLoader from '@/pages/dashboard/_charts/ChartLoader';
import LineChart from '@/pages/dashboard/_charts/LineChart';
import colors from 'tailwindcss/colors';
import {useEventsContext} from '@/pages/dashboard/EventsContext';
import getActivityChartData from "@/pages/dashboard/_utils/getActivityChartData";

export default function ActivityByMonth(props) {
  const {timestamps} = props;
  const {filteredEvents, isLoadingEvents} = useEventsContext();

  if (isLoadingEvents) {
    return (
      <ChartLoader
        title="Event Activity"
        subtitle="Over school year"
      />
    );
  }

  const {series, labels} = useMemo(() =>
    getActivityChartData(filteredEvents, timestamps), [filteredEvents, timestamps]);

  return (
    <LineChart
      title="Event Activity"
      subtitle="Over school year"
      labels={labels}
      series={series}
      colors={[
        colors.yellow['400'],
        colors.blue['400'],
        colors.emerald['400'],
        colors.red['400']
      ]}
    />
  );
}
